export default {
  name: 'marking--requestStatus',
};